import Flex, { FlexProps } from '@Components/Bases/Flex';
import { FormInput } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import FormatNumberInput from '@Components/FormattedNumberInput';
import { Box, InputLabel, styled, Typography } from '@mui/material';

const FormNumberInput = styled(FormInput)({
  '& input': {
    textAlign: 'right',
  },
});

type GhGasEmissionOrgFormFieldTypes = {
  scope: string;
  inputProps: { name: string };
  isCompleteTh?: boolean;
  isCompleteEn?: boolean;
} & FlexProps;

const GhGasEmissionOrgFormFields = (props: GhGasEmissionOrgFormFieldTypes) => {
  const {
    scope,
    inputProps,
    isCompleteTh = false,
    isCompleteEn = false,
    ...restProps
  } = props;

  return (
    <Flex width={1} alignItems={'center'} {...restProps}>
      <Box width={1} minWidth={235} maxWidth={350}>
        <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }}>
          {scope}
        </InputLabel>
        <Typography textAlign={'right'} color={'text.secondary'}>
          {`(ตันคาร์บอนไดออกไซด์เทียบเท่า)`}
        </Typography>
      </Box>
      <Box
        width={1}
        display={'grid'}
        gridTemplateColumns={'repeat(3, 1fr)'}
        gap={3}
        ml={1}
      >
        <FormNumberInput
          name={`${inputProps.name}.asOfYearBeforeYesteryear`}
          placeholder={'กรุณาระบุจำนวน'}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
              inputProps: {
                allowNegative: false,
              },
            },
          }}
          sx={
            isCompleteTh || isCompleteEn ? disabledFormInputStyles : undefined
          }
          fullWidth
        />
        <FormNumberInput
          name={`${inputProps.name}.asOfYesteryear`}
          placeholder={'กรุณาระบุจำนวน'}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
              inputProps: {
                allowNegative: false,
              },
            },
          }}
          sx={
            isCompleteTh || isCompleteEn ? disabledFormInputStyles : undefined
          }
          fullWidth
        />
        <FormNumberInput
          name={`${inputProps.name}.asOfYear`}
          placeholder={'กรุณาระบุจำนวน'}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
              inputProps: {
                allowNegative: false,
              },
            },
          }}
          sx={
            isCompleteTh || isCompleteEn ? disabledFormInputStyles : undefined
          }
          fullWidth
        />
      </Box>
    </Flex>
  );
};

export default GhGasEmissionOrgFormFields;
